module.exports = __webpack_public_path__ + "media/svg-new/avatar-8 2-028521ce.svg";